import React from 'react'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import MealContent from '../components/MealContent'


const Page = ({ data }) => {
  const { wpMeal: page } = data

  return (
    
      <Layout>
        <MealContent 
          title={page.title} 
          aLaCartePrice={page.mealOptions.aLaCartePrice} 
          description={page.mealOptions.description} 
          subtitle={page.mealOptions.subtitle} 
          fieldGroupName={page.mealOptions.fieldGroupName} 
          largePrice={page.mealOptions.largePrice} 
          largePriceDescription={page.mealOptions.largePriceDescription} 
          mealType={page.mealOptions.mealType} 
          menus={page.mealOptions.menus} 
          regularPrice={page.mealOptions.regularPrice} 
          regularPriceDescription={page.mealOptions.regularPriceDescription} 
          smallPrice={page.mealOptions.smallPrice} 
          smallPriceDescription={page.mealOptions.smallPriceDescription}
          content={page.content}
          image={page.featuredImage} />
      </Layout>
       
  )
}

export default Page

export const pageQuery = graphql`
  query MealById($id: String!) {
    wpMeal(id: { eq: $id }) {
      title
      content
      featuredImage {
        node {
          uri
          mediaItemUrl
          srcSet
        }
      }
      mealOptions {
        aLaCartePrice
        description
        subtitle
        fieldGroupName
        largePrice
        largePriceDescription
        mealType
        menus {
          ... on WpZMenu {
            id
            title
            uri
            slug
          }
        }
        regularPrice
        regularPriceDescription
        smallPriceDescription
        smallPrice
      }
    }
  }
`